export const getMenu = state => {
  return state.Menu || null
}
export const getMenuActive = state => {
  return state.MenuActive || [0, 0]
}
export const getCourseActive = state => {
  return state.CourseActive || [0, 0]
}
export const getIndexActive = state => {
  return state.IndexActive || ''
}
export const getCourse = state => {
  return state.Course || null
}
export const getPartList = state => {
  return state.PartList || null
}
export const getGroup = state => {
  return state.Group || null
}
export const getBread = state => {
  return state.Bread || null
}
export const getCredential = state => {
  return state.Credential || false
}
export const getDefinition = state => {
  return state.Definition || 'LD'
}
export const getPlayAuth = state => {
  return state.PlayAuth || null
}
export const getSubCourse = state => {
  return state.SubCourse || null
}
export const getInfomationStatus = state => {
  return state.InfomationStatus
}
export const getServerTime = state => () => {
  return Date.now() + state.serverTimeOffset
}
